export const REQUEST_NOTICE_LIST_FOR_MAIN_PAGE = 'REQUEST_NOTICE_LIST_FOR_MAIN_PAGE';
export const REQUEST_NOTICE_LIST = 'REQUEST_NOTICE_LIST'
export const REQUEST_NOTICE_DTL = 'REQUEST_NOTICE_DTL'